import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { DefaultComponentsProvider } from "~/components/article/article-render";
import type { newsletterArticleArticle$key } from "~/queries/__generated__/newsletterArticleArticle.graphql";

import {
  AuthorDetail,
  CommentTrigger,
  Container,
  ShareContainer,
  ShareWidget,
  StyledNewsletterArticleHeader,
  StyledNewsletterArticleIssues,
} from "./styles";

type Props = {
  content: newsletterArticleArticle$key;
  provider: DefaultComponentsProvider;
};

export const NewsletterArticle: FunctionComponent<Props> = ({ content: content_, provider }) => {
  const content = useFragment(
    graphql`
      fragment newsletterArticleArticle on Article {
        ...headerNewsletterArticleArticle
        ...issuesNewsletterArticleArticle
      }
    `,
    content_,
  );

  // TODO: iframe from the 1st relatedLinks[]
  // TODO: newsletter widget from all the relatedNewsletters[], in order

  return (
    <Container>
      <StyledNewsletterArticleHeader content={content} provider={provider} />
      <div>newsletter widget container</div>
      <div>iframe from related links</div>
      <StyledNewsletterArticleIssues content={content} />
      <ShareContainer>
        <CommentTrigger>{provider.commentTrigger()}</CommentTrigger>
        <ShareWidget>
          {provider.shareWidget({
            variant: "newsletter",
          })}
        </ShareWidget>
      </ShareContainer>
      <AuthorDetail>{provider.authorDetails()}</AuthorDetail>
      <div>{provider.topics()}</div>
    </Container>
  );
};

NewsletterArticle.displayName = "NewsletterArticle";
